import * as S from './Tag.styled';

export default S.Tag;
